import React, { useState } from 'react';

import { DataGridCustomToolbarRightSideActions, DataGridPremium, Tabs, TabsContent } from '@clatter/ui';


/** this is so TS components stop complaining
 * @typedef {Object} ReportDetailsSectionProps
 * @property {boolean} loading
 * @property {string} exportFileName
 * @property {*} tabsData
 * @property {boolean} [wrapContent]
 * @property {boolean} [enableRowDeselect]
 * @property {boolean} [rowAutoHeight]
 * @property {*} [dataGridProps]
 */

/** @param {ReportDetailsSectionProps} props */
export const ReportDetailsSection = ({
  loading = false,
  rows = [],
  columns = [],
  exportFileName,
  tableName,
  tabsData = null,
  minHeight,
  getRowId = (row) => row.id,
  defaultSortField,
  wrapContent = false,
  rowAutoHeight = false,
  enableRowDeselect = false,
  dataGridProps,
}) => {
  const [activeTab, setActiveTab] = useState(0);

  if (!tabsData) {
    return (
      <DataGridPremium
        loading={loading}
        renderCustomToolbar={() => <DataGridCustomToolbarRightSideActions exportFileName={exportFileName} />}
        getRowId={getRowId}
        name={tableName} //  "report/active-users"
        columns={columns}
        rows={rows}
        exportFileName={exportFileName}
        defaultSortField={defaultSortField}
        wrapContent={wrapContent}
        rowAutoHeight={rowAutoHeight}
        enableRowDeselect={enableRowDeselect}
        dataGridProps={dataGridProps}
      />
    );
  }

  return (
    <>
      <Tabs tabs={tabsData?.tabs} activeTab={activeTab} onTabChange={setActiveTab}>
        {tabsData?.tabsData?.map((tableData, index) => {
          return (
            <TabsContent key={`${index}-details-report-tab`} minHeight={minHeight}>
              <DataGridPremium
                loading={loading}
                renderCustomToolbar={() => <DataGridCustomToolbarRightSideActions exportFileName={tableData?.exportFileName} />}
                getRowId={(row) => row.id}
                name={tableData?.tableName} //  "report/active-users"
                columns={tableData?.columns}
                rows={tableData?.rows}
                exportFileName={tableData?.exportFileName}
                defaultSortField={{ field: 'count', sort: 'desc' }}
                wrapContent={wrapContent}
                rowAutoHeight={rowAutoHeight}
                enableRowDeselect={enableRowDeselect}
                dataGridProps={tableData?.dataGridProps}
              />
            </TabsContent>
          );
        })}
      </Tabs>
    </>
  );
};
